"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMPWWorkshopData = exports.createAdditionalIdeas = exports.createDigitalMarketing = exports.createMassMarketingVehicles = exports.createGuerrillaMarketingIdeas = exports.createRetainAndGrowCurrentCustomers = exports.createBasics = exports.createMPWPreworkData = exports.productionStagesInfo = exports.productionStages = exports.targetAudienceOptions = exports.orderMarketingWorksheetSections = exports.marketingPlanItemDefaultData = exports.marketingWorksheetSections = exports.createTrackingData = exports.createFutureMarketingPlanItem = exports.createCustomMarketingWorksheetItem = void 0;
const mpwHelpers_1 = require("./mpwHelpers");
const ulid_1 = require("ulid");
// TODO TP-1850: Updated this to set theID pattern from BE
function createCustomMarketingWorksheetItem(memberId, fiscalYear, groupKey, groupId, idx) {
    return {
        fiscalYear,
        groupId,
        memberId,
        secondaryId: (0, mpwHelpers_1.generateGroupSK)(`MPW#${fiscalYear}#WORKSHOP`, groupKey, idx),
        id: (0, mpwHelpers_1.generateGroupSK)(`MPW#${fiscalYear}#WORKSHOP`, groupKey, groupId),
        tactic: "",
        notes: null,
        numberOfPrograms: null,
        totalAnnualCosts: null,
        priority: null,
        use: false,
        custom: true,
        futureMarketingPlan: [],
    };
}
exports.createCustomMarketingWorksheetItem = createCustomMarketingWorksheetItem;
// TODO TP-1850: updated this to build the new id format
/**
 *
 * @param memberId
 * @param fiscalYear
 * @param base
 * @param fmpId
 * @param idx
 */
function createFutureMarketingPlanItem(memberId, fiscalYear, base, fmpId, idx) {
    return {
        fiscalYear,
        fmpId: fmpId,
        memberId,
        secondaryId: (0, mpwHelpers_1.generateFMPKey)(base, idx),
        id: (0, mpwHelpers_1.generateFMPKey)(base, fmpId),
        campaignName: null,
        reasonWhySelected: null,
        goal: null,
        requiresProduction: null,
        targetAudience: null,
        estimatedAnnualCampaignCost: null,
        productionChart: {
            designAndWrite: {
                vendor: null,
                startDate: null,
                completionDate: null,
            },
            printBroadcastProduction: {
                vendor: null,
                startDate: null,
                completionDate: null,
            },
            // DEV-741 coaches asked to remove this option
            // purchaseListOrMedia: {
            //   vendor: null,
            //   startDate: null,
            //   completionDate: null,
            // },
            orderProduct: {
                vendor: null,
                startDate: null,
                completionDate: null,
            },
        },
        implementationChart: {
            jan: null,
            feb: null,
            mar: null,
            apr: null,
            may: null,
            jun: null,
            jul: null,
            aug: null,
            sep: null,
            oct: null,
            nov: null,
            dec: null,
        },
        trackingData: createTrackingData(),
    };
}
exports.createFutureMarketingPlanItem = createFutureMarketingPlanItem;
function createTrackingData() {
    return {
        assessment: null,
        continueToUse: null,
        opportunityForImprovement: null,
        monthlyData: {
            jan: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            feb: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            mar: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            apr: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            may: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            jun: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            jul: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            aug: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            sep: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            oct: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            nov: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
            dec: {
                actualCost: null,
                totalCalls: null,
                callsRan: null,
                revenue: null,
            },
        },
    };
}
exports.createTrackingData = createTrackingData;
exports.marketingWorksheetSections = {
    basics: "The Basics",
    retainAndGrowCurrentCustomers: "Loyalty",
    guerrillaMarketingIdeas: "Local Marketing",
    massMarketingVehicles: "Mass Marketing",
    digitalMarketing: "Paid Lead Generation",
    additionalIdeas: "Operational Marketing",
};
exports.marketingPlanItemDefaultData = {
    marketingTool: null,
    goal: null,
    campaignName: null,
    totalCalls: null,
    callsRan: null,
    actualCost: null,
    revenue: null,
    assessment: null,
    opportunityForImprovement: null,
    continueToUse: "YES",
    id: null,
};
exports.orderMarketingWorksheetSections = Object.keys(exports.marketingWorksheetSections);
exports.targetAudienceOptions = {
    current: "Current",
    prospect: "Prospect",
    both: "Both",
    lapsed: "Lapsed",
};
exports.productionStages = [
    "designAndWrite",
    "printBroadcastProduction",
    "orderProduct",
];
exports.productionStagesInfo = {
    designAndWrite: "Design & Write",
    printBroadcastProduction: "Print/Broadcast Production",
    orderProduct: "Order Product",
};
function createMPWPreworkData(memberId, year) {
    return {
        PK: `MEMBER#${memberId}`,
        fiscalYear: year,
        SK: `MPW#${year}#PREWORK`,
        historicalSalesProfits: {
            yearMinusOne: {
                year: (year - 1).toString(),
                annualSales: null,
                netProfit: null,
                annualSalesChange: null,
                netProfitChange: null,
            },
            yearMinusTwo: {
                year: (year - 2).toString(),
                annualSales: null,
                netProfit: null,
                annualSalesChange: null,
                netProfitChange: null,
            },
            yearMinusThree: {
                year: (year - 3).toString(),
                annualSales: null,
                netProfit: null,
                annualSalesChange: null,
                netProfitChange: null,
            },
            yearMinusFour: {
                year: (year - 4).toString(),
                annualSales: null,
                netProfit: null,
                annualSalesChange: null,
                netProfitChange: null,
            },
            yearMinusFive: {
                year: (year - 5).toString(),
                annualSales: null,
                netProfit: null,
                annualSalesChange: null,
                netProfitChange: null,
            },
        },
        factorsInfluencedChange: {
            items: ["", "", ""],
        },
        marketingEffectivenessConcerns: {
            items: ["", "", ""],
        },
        strengths: {
            items: ["", "", ""],
        },
        weaknesses: {
            items: ["", "", ""],
        },
        opportunities: {
            items: ["", "", ""],
        },
        threats: {
            items: ["", "", ""],
        },
        keyIssues: {
            items: ["", "", ""],
        },
        financialGoals: {
            items: ["", "", ""],
        },
        marketingGoals: {
            items: ["", "", "", "", ""],
        },
        // DEV-740: BK -- removed the Target Audience section with these fields
        // currentCustomerProfile: {
        //   items: ["", "", ""],
        // },
        // prospectProfile: {
        //   items: ["", "", ""],
        // },
        // customerOrProspectWants: {
        //   items: ["", "", ""],
        // },
        numberOfCompetitors: null,
        primaryCompetitorDescriptions: {
            items: ["", "", ""],
        },
        competitorMarketingNotes: {
            items: ["", "", ""],
        },
        competitorStrengths: {
            items: ["", "", ""],
        },
        competitorWeaknesses: {
            items: ["", "", ""],
        },
        keyWants: {
            items: ["", "", ""],
        },
        companyDescription: null,
        businessDifferences: null,
        marketingBudget: null,
        currentMarketingPlan: [],
        currentCustomersHVAC: null,
        currentCustomersPlumbing: null,
        currentCustomersElectrical: null,
        currentCustomersSpp: null,
        sppPlan: false,
        updatedAt: null,
        updatedBy: null,
    };
}
exports.createMPWPreworkData = createMPWPreworkData;
function createBasics(memberId, year) {
    const ulid0 = (0, ulid_1.ulid)();
    const ulid1 = (0, ulid_1.ulid)();
    const ulid2 = (0, ulid_1.ulid)();
    const ulid3 = (0, ulid_1.ulid)();
    const ulid4 = (0, ulid_1.ulid)();
    const ulid6 = (0, ulid_1.ulid)();
    const ulid7 = (0, ulid_1.ulid)();
    const ulid8 = (0, ulid_1.ulid)();
    const ulid9 = (0, ulid_1.ulid)();
    const ulid100 = (0, ulid_1.ulid)();
    const ulid101 = (0, ulid_1.ulid)();
    const ulid102 = (0, ulid_1.ulid)();
    const ulid103 = (0, ulid_1.ulid)();
    const ulid104 = (0, ulid_1.ulid)();
    const ulid105 = (0, ulid_1.ulid)();
    // DEV-938: BK -- the reason you're seeing the jump in ulid numbers from 9 to 100 (and some missing numbers) is because the coaches updated the list of default tactics. Doing the numbers this way ensures that we are still getting matches on data that is generated from previous years while also making sure the new tactics don't overwrite previous custom tactics.
    return [
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid0}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#0`,
            groupId: ulid0,
            fiscalYear: year,
            tactic: "Company Name (new or revision)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid1}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#1`,
            groupId: ulid1,
            fiscalYear: year,
            tactic: "Logo (new or revision)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid2}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#2`,
            groupId: ulid2,
            fiscalYear: year,
            tactic: "Slogan (new or revision)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid3}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#3`,
            groupId: ulid3,
            fiscalYear: year,
            tactic: "Business Cards and Letterhead",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Equipment Stickers",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid6}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#6`,
            groupId: ulid6,
            fiscalYear: year,
            tactic: "Presentation Folders",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid7}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#7`,
            groupId: ulid7,
            fiscalYear: year,
            tactic: "Yard Signs",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid8}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#8`,
            groupId: ulid8,
            fiscalYear: year,
            tactic: "Thank-You Notes",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid9}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#9`,
            groupId: ulid9,
            fiscalYear: year,
            tactic: "Truck Graphics",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid100}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#100`,
            groupId: ulid100,
            fiscalYear: year,
            tactic: "Website",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid101}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#101`,
            groupId: ulid101,
            fiscalYear: year,
            tactic: "Search Engine Optimization/Local SEO",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid102}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#102`,
            groupId: ulid102,
            fiscalYear: year,
            tactic: "Email",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid103}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#103`,
            groupId: ulid103,
            fiscalYear: year,
            tactic: "Valve Tags",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid104}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#104`,
            groupId: ulid104,
            fiscalYear: year,
            tactic: "Company Brochure",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#BASICS#${ulid105}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#BASICS#105`,
            groupId: ulid105,
            fiscalYear: year,
            tactic: "Reviews/Reputation Management",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createBasics = createBasics;
function createRetainAndGrowCurrentCustomers(memberId, year) {
    const ulid0 = (0, ulid_1.ulid)();
    const ulid4 = (0, ulid_1.ulid)();
    const ulid5 = (0, ulid_1.ulid)();
    const ulid6 = (0, ulid_1.ulid)();
    const ulid9 = (0, ulid_1.ulid)();
    const ulid10 = (0, ulid_1.ulid)();
    const ulid11 = (0, ulid_1.ulid)();
    const ulid13 = (0, ulid_1.ulid)();
    const ulid100 = (0, ulid_1.ulid)();
    const ulid101 = (0, ulid_1.ulid)();
    const ulid102 = (0, ulid_1.ulid)();
    return [
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid0}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#0`,
            groupId: ulid0,
            fiscalYear: year,
            tactic: "Direct Mail (Current Customers + SPPs)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Email",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid5}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#5`,
            groupId: ulid5,
            fiscalYear: year,
            tactic: "Text Messaging",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid6}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#6`,
            groupId: ulid6,
            fiscalYear: year,
            tactic: "Gift Cards",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid9}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#9`,
            groupId: ulid9,
            fiscalYear: year,
            tactic: "SPP Welcome Pack/Letter/Gift",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid10}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#10`,
            groupId: ulid10,
            fiscalYear: year,
            tactic: "SPP Unexpected Gift",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid11}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#11`,
            groupId: ulid11,
            fiscalYear: year,
            tactic: "Direct Mail (SPP Exclusive Offer)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid13}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#13`,
            groupId: ulid13,
            fiscalYear: year,
            tactic: "SPP Brochure",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid100}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#100`,
            groupId: ulid100,
            fiscalYear: year,
            tactic: "Direct Mail (Lapsed Customers)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid101}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#101`,
            groupId: ulid101,
            fiscalYear: year,
            tactic: "Social Media – Organic",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#${ulid102}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#RETAINANDGROWCURRENTCUSTOMERS#102`,
            groupId: ulid102,
            fiscalYear: year,
            tactic: "Referral Program",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createRetainAndGrowCurrentCustomers = createRetainAndGrowCurrentCustomers;
function createGuerrillaMarketingIdeas(memberId, year) {
    const ulid2 = (0, ulid_1.ulid)();
    const ulid3 = (0, ulid_1.ulid)();
    const ulid4 = (0, ulid_1.ulid)();
    const ulid5 = (0, ulid_1.ulid)();
    const ulid6 = (0, ulid_1.ulid)();
    const ulid9 = (0, ulid_1.ulid)();
    const ulid11 = (0, ulid_1.ulid)();
    const ulid12 = (0, ulid_1.ulid)();
    return [
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid2}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#2`,
            groupId: ulid2,
            fiscalYear: year,
            tactic: "Common Problems / Situation Letters",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid3}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#3`,
            groupId: ulid3,
            fiscalYear: year,
            tactic: "New Homeowners Letter",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Auctions",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid5}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#5`,
            groupId: ulid5,
            fiscalYear: year,
            tactic: "Networking Clubs",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid6}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#6`,
            groupId: ulid6,
            fiscalYear: year,
            tactic: "Church, School & Other Non-Profit Partnerships",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid9}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#9`,
            groupId: ulid9,
            fiscalYear: year,
            tactic: "Door Hangers",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid11}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#11`,
            groupId: ulid11,
            fiscalYear: year,
            tactic: "Home Shows",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#${ulid12}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#GUERRILLAMARKETINGIDEAS#12`,
            groupId: ulid12,
            fiscalYear: year,
            tactic: "Comfort Stations",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createGuerrillaMarketingIdeas = createGuerrillaMarketingIdeas;
function createMassMarketingVehicles(memberId, year) {
    const ulid0 = (0, ulid_1.ulid)();
    const ulid3 = (0, ulid_1.ulid)();
    const ulid4 = (0, ulid_1.ulid)();
    const ulid5 = (0, ulid_1.ulid)();
    const ulid6 = (0, ulid_1.ulid)();
    const ulid7 = (0, ulid_1.ulid)();
    const ulid8 = (0, ulid_1.ulid)();
    const ulid100 = (0, ulid_1.ulid)();
    return [
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid0}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#0`,
            groupId: ulid0,
            fiscalYear: year,
            tactic: "Building Signs",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid3}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#3`,
            groupId: ulid3,
            fiscalYear: year,
            tactic: "Direct Mail - Prospects",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Newspaper / Magazine Ads",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid5}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#5`,
            groupId: ulid5,
            fiscalYear: year,
            tactic: "Out-of-Home (billboards, sports arenas)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid6}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#6`,
            groupId: ulid6,
            fiscalYear: year,
            tactic: "Radio / Streaming",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid7}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#7`,
            groupId: ulid7,
            fiscalYear: year,
            tactic: "Television / OTT",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid8}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#8`,
            groupId: ulid8,
            fiscalYear: year,
            tactic: "Video / Audio Production",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#${ulid100}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#MASSMARKETINGVEHICLES#100`,
            groupId: ulid100,
            fiscalYear: year,
            tactic: "Video Content Creation",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createMassMarketingVehicles = createMassMarketingVehicles;
function createDigitalMarketing(memberId, year) {
    const ulid4 = (0, ulid_1.ulid)();
    const ulid5 = (0, ulid_1.ulid)();
    const ulid6 = (0, ulid_1.ulid)();
    const ulid7 = (0, ulid_1.ulid)();
    const ulid9 = (0, ulid_1.ulid)();
    return [
        {
            id: `MPW#${year}#WORKSHOP#DIGITALMARKETING#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#DIGITALMARKETING#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Pay-Per-Click",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#DIGITALMARKETING#${ulid5}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#DIGITALMARKETING#5`,
            groupId: ulid5,
            fiscalYear: year,
            tactic: "Google Local Service Ads (LSA)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#DIGITALMARKETING#${ulid6}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#DIGITALMARKETING#6`,
            groupId: ulid6,
            fiscalYear: year,
            tactic: "Online Lead Generation (e.g., Service Direct, Angi)",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#DIGITALMARKETING#${ulid7}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#DIGITALMARKETING#7`,
            groupId: ulid7,
            fiscalYear: year,
            tactic: "Online Display Ads",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#DIGITALMARKETING#${ulid9}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#DIGITALMARKETING#9`,
            groupId: ulid9,
            fiscalYear: year,
            tactic: "Social Media Ads",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createDigitalMarketing = createDigitalMarketing;
function createAdditionalIdeas(memberId, year) {
    const ulid0 = (0, ulid_1.ulid)();
    const ulid1 = (0, ulid_1.ulid)();
    const ulid2 = (0, ulid_1.ulid)();
    const ulid4 = (0, ulid_1.ulid)();
    const ulid5 = (0, ulid_1.ulid)();
    const ulid100 = (0, ulid_1.ulid)();
    return [
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid0}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#0`,
            groupId: ulid0,
            fiscalYear: year,
            tactic: "Outbound Calling",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid1}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#1`,
            groupId: ulid1,
            fiscalYear: year,
            tactic: "Unsold Jobs",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid2}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#2`,
            groupId: ulid2,
            fiscalYear: year,
            tactic: "In-home Cross-selling flyers",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid4}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#4`,
            groupId: ulid4,
            fiscalYear: year,
            tactic: "Happy Calls",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid5}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#5`,
            groupId: ulid5,
            fiscalYear: year,
            tactic: "Coloring Books",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
        {
            id: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#${ulid100}`,
            memberId: `MEMBER#${memberId}`,
            secondaryId: `MPW#${year}#WORKSHOP#ADDITIONALIDEAS#100`,
            groupId: ulid100,
            fiscalYear: year,
            tactic: "In-home Promotion flyers",
            notes: null,
            numberOfPrograms: null,
            totalAnnualCosts: null,
            priority: null,
            use: false,
            custom: false,
            futureMarketingPlan: [],
        },
    ];
}
exports.createAdditionalIdeas = createAdditionalIdeas;
function createMPWWorkshopData(memberId, year) {
    return {
        id: `MPW#${year}#WORKSHOP`,
        memberId: `MEMBER#${memberId}`,
        secondaryId: `MPW#${year}#WORKSHOP`,
        fiscalYear: year,
        fiscalYearEnd: null,
        updatedAt: null,
        updatedBy: null,
        marketingWorksheet: {
            annualMarketingBudget: null,
            basics: {
                items: createBasics(memberId, year),
                canAdd: false,
            },
            retainAndGrowCurrentCustomers: {
                items: createRetainAndGrowCurrentCustomers(memberId, year),
                canAdd: true,
            },
            guerrillaMarketingIdeas: {
                items: createGuerrillaMarketingIdeas(memberId, year),
                canAdd: true,
            },
            massMarketingVehicles: {
                items: createMassMarketingVehicles(memberId, year),
                canAdd: true,
            },
            digitalMarketing: {
                items: createDigitalMarketing(memberId, year),
                canAdd: true,
            },
            additionalIdeas: {
                items: createAdditionalIdeas(memberId, year),
                canAdd: true,
            },
        },
    };
}
exports.createMPWWorkshopData = createMPWWorkshopData;
